<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'2-10'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>메인화면 관리 - 팝업 {{ statusData.isEdit ? '수정' : '등록' }}</p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" @click="check_form">
              {{ statusData.isEdit ? '수정' : '등록' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <!-- 제목 -->
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for="title">타이틀<span class="pointTextRed"> * </span></label>
              <input class="Admin_PageDetail_inputText" id="title" v-model="formData.title" maxlength="200" />
            </div>
            <p class="Admin_ErrorBox">{{ errorData.titleError }}</p>
          </div>

          <!-- 사용여부 -->
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for="is_use">사용 여부<span class="pointTextRed"> * </span></label>
              <select class="Admin_PageDetail_inputSelect" id="is_use" v-model="formData.is_use">
                <option value="1">사용</option>
                <option value="0">미사용</option>
              </select>
            </div>
          </div>

          <!-- 디바이스 -->
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for="device_type">디바이스</label>
              <select class="Admin_PageDetail_inputSelect" id="device_type" v-model="formData.device_type">
                <option value="ALL">ALL</option>
                <option value="PC">PC</option>
                <option value="MOBILE">MOBILE</option>
              </select>
            </div>
          </div>

          <!-- 기간 -->
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for="start_at">노출 시작</label>
              <input class="Admin_PageDetail_inputText" type="datetime-local" id="start_at" v-model="formData.start_at" />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for="end_at">노출 종료</label>
              <input class="Admin_PageDetail_inputText" type="datetime-local" id="end_at" v-model="formData.end_at" />
            </div>
            <p class="Admin_ErrorBox">{{ errorData.dateError }}</p>
          </div>

          <!-- 링크 -->
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for="link_url">링크 URL</label>
              <input class="Admin_PageDetail_inputText" id="link_url" v-model="formData.link_url" />
            </div>
          </div>

          <!-- 이미지 업로드 UI: 롤링배너 클래스 구조 참고해서 동일 패턴 적용 -->
          <div class="Admin_imgBanner_BoxWrap">
            <div class="Admin_imgBanner_BoxTit">팝업 이미지</div>

            <!-- PC -->
            <div
              class="Admin_imgBanner_Box"
              v-if="formData.device_type === 'ALL' || formData.device_type === 'PC'"
            >
              <div class="Admin_imgBanner_TextBox">
                <p>PC용 이미지<span class="pointTextRed"> * </span></p>
                <!-- 필요하면 사이즈 안내 문구만 바꿔 -->
                <p class="Admin_imgBanner_SubTit">사이즈 : 420 x 420px</p>
                <label for="popup_pc_image" class="Admin_imgBanner_Btn">
                  {{ statusData.isEdit ? '변경' : '추가' }}
                </label>
              </div>

              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type="file"
                  id="popup_pc_image"
                  accept="image/gif, image/jpeg, image/png"
                  @change="changePcImage"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_RollingPc">
                  <img
                    :src="statusData.pcPreview === '' ? require(`@/assets/images/etc/no_image.gif`) : statusData.pcPreview"
                    alt="PC용 이미지"
                  />
                </p>
                <p class="Admin_ErrorBox">{{ errorData.pcImageError }}</p>
              </div>
            </div>

            <!-- MOBILE -->
            <div
              class="Admin_imgBanner_Box"
              v-if="formData.device_type === 'ALL' || formData.device_type === 'MOBILE'"
            >
              <div class="Admin_imgBanner_TextBox">
                <p>모바일용 이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 420 x 420px</p>
                <label for="popup_mobile_image" class="Admin_imgBanner_Btn">
                  {{ statusData.isEdit ? '변경' : '추가' }}
                </label>
              </div>

              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type="file"
                  id="popup_mobile_image"
                  accept="image/gif, image/jpeg, image/png"
                  @change="changeMobileImage"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_RollingMo">
                  <img
                    :src="statusData.mobilePreview === '' ? require(`@/assets/images/etc/no_image.gif`) : statusData.mobilePreview"
                    alt="모바일용 이미지"
                  />
                </p>
                <p class="Admin_ErrorBox">{{ errorData.mobileImageError }}</p>
              </div>
            </div>
          </div>
          <!-- /이미지 -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import { get_popup_one, create_popup, update_popup } from '../../ETC/Axios.vue'

export default {
  name: 'AdminPopupManagementAdd',
  components: { AdminHeader, AdminFooter, Spiner },
  data () {
    return {
      formData: {
        popup_id: 0,
        title: '',
        is_use: '1',
        device_type: 'ALL',
        start_at: '',
        end_at: '',
        link_url: ''
      },
      files: { pc: null, mobile: null },
      errorData: {
        titleError: '',
        dateError: '',
        pcImageError: '',
        mobileImageError: ''
      },
      statusData: {
        spinnerStatus: false,
        isEdit: false,
        pcPreview: '',
        mobilePreview: ''
      }
    }
  },
  methods: {
    toDateTimeLocal (v) {
      if (!v) return ''
      return String(v).replace(' ', 'T').substring(0, 16)
    },

    // 롤링배너랑 동일하게 DataURL 미리보기
    changePcImage (e) {
      const f = e.target.files && e.target.files[0]
      if (!f) return
      this.files.pc = f
      const reader = new FileReader()
      reader.readAsDataURL(f)
      reader.onloadend = () => { this.statusData.pcPreview = reader.result }
    },
    changeMobileImage (e) {
      const f = e.target.files && e.target.files[0]
      if (!f) return
      this.files.mobile = f
      const reader = new FileReader()
      reader.readAsDataURL(f)
      reader.onloadend = () => { this.statusData.mobilePreview = reader.result }
    },

    validate () {
      let ok = true

      if (!this.formData.title) {
        this.errorData.titleError = '타이틀을 입력해 주세요.'
        ok = false
      } else this.errorData.titleError = ''

      if (this.formData.start_at && this.formData.end_at && this.formData.start_at > this.formData.end_at) {
        this.errorData.dateError = '노출 시작일이 종료일보다 클 수 없습니다.'
        ok = false
      } else this.errorData.dateError = ''

      this.errorData.pcImageError = ''
      this.errorData.mobileImageError = ''

      const needPc = (this.formData.device_type === 'ALL' || this.formData.device_type === 'PC')
      const needMobile = (this.formData.device_type === 'ALL' || this.formData.device_type === 'MOBILE')

      // 수정 시: 기존 이미지 URL로 pcPreview/mobilePreview 채워지므로 OK
      if (needPc && !this.files.pc && !this.statusData.pcPreview) {
        this.errorData.pcImageError = 'PC 이미지를 업로드해 주세요.'
        ok = false
      }
      if (needMobile && !this.files.mobile && !this.statusData.mobilePreview) {
        this.errorData.mobileImageError = '모바일 이미지를 업로드해 주세요.'
        ok = false
      }

      return ok
    },

    buildFormData () {
      const fd = new FormData()
      fd.append('popup_id', String(this.formData.popup_id))
      fd.append('title', this.formData.title)
      fd.append('is_use', String(this.formData.is_use))
      fd.append('device_type', this.formData.device_type)
      fd.append('start_at', this.formData.start_at ? this.formData.start_at.replace('T', ' ') + ':00' : '')
      fd.append('end_at', this.formData.end_at ? this.formData.end_at.replace('T', ' ') + ':00' : '')
      fd.append('link_url', this.formData.link_url || '')

      if (this.files.pc) fd.append('pc_image', this.files.pc)
      if (this.files.mobile) fd.append('mobile_image', this.files.mobile)

      return fd
    },

    check_form () {
      if (!this.validate()) {
        alert('필수 입력값을 확인해주세요.')
        return
      }

      this.statusData.spinnerStatus = true
      const fd = this.buildFormData()

      const req = this.statusData.isEdit ? update_popup(fd) : create_popup(fd)
      req.then(() => {
        this.statusData.spinnerStatus = false
        alert(this.statusData.isEdit ? '수정이 완료되었습니다.' : '등록이 완료되었습니다.')
        window.location.href = '/AdminPopupManagement'
      }).catch(() => {
        this.statusData.spinnerStatus = false
        alert('처리 중 오류가 발생했습니다.')
      })
    }
  },

  mounted () {
    const popup_id = this.$route.query.popup_id
    if (!popup_id) return

    this.statusData.isEdit = true
    this.formData.popup_id = Number(popup_id)

    // get_popup_one 호출부는 "popup_id 객체"로 보내는 쪽/받는 쪽 키가 맞아야 함
    // (이전 이슈처럼 popup_ID / popup_id 섞이면 result[0] undefined 터짐)
    get_popup_one(popup_id).then((result) => {
      if (!result || !result[0]) return

      const p = result[0]
      this.formData.title = p.title
      this.formData.is_use = String(p.is_use)
      this.formData.device_type = p.device_type
      this.formData.start_at = this.toDateTimeLocal(p.start_at)
      this.formData.end_at = this.toDateTimeLocal(p.end_at)
      this.formData.link_url = p.link_url || ''

      // 서버에서 접근 가능한 URL을 내려주는 전제
      this.statusData.pcPreview = p.pc_image_url || ''
      this.statusData.mobilePreview = p.mobile_image_url || ''
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/MainManagement/AdminPopupManagementAdd.vue